import axios from "axios"
import axiosRetry from "axios-retry"

const SERVICE = `content-service`
const BASE_URL = window.myNtucConfig.mpBaseUrl
const VERSION = process.env.REACT_APP_MP_VERSION

const client = axios.create({
    baseURL: `${BASE_URL}/${SERVICE}/${VERSION}/`,
})

axiosRetry(axios, { retries: 3, retryDelay: axiosRetry.exponentialDelay })

export default client
